import Vue from "vue";

Vue.directive("onlyNum", {
  bind(el, binding, vnode) {
    let ele = el.tagName === "INPUT" ? el : el.querySelector("input");
    ele.oninput = function() {
      let val = ele.value,
        arg = parseInt(binding.arg);
      if (arg) {
        val = val.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
        val = val.replace(/^\./g, ""); //验证第一个字符是数字
        val = val.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
        val = val
          .replace(".", "$#$")
          .replace(/\./g, "")
          .replace("$#$", ".");
        let reg = new RegExp(`^(\\-)*(\\d+)\\.(\\d{${arg}}).*$`);
        val = val.replace(reg, "$1$2.$3"); //只能输入三个小数
      } else {
        val = val.replace(/[^\d]/g, "");
      }
      ele.value = val;
    };
  },
});

Vue.directive("onblur", {
  bind(el, binding, vnode) {
    let ele = el.tagName === "INPUT" ? el : el.querySelector("input");
    ele.onblur = function() {
      console.log(vnode);
      let val = ele.value;
      if (val == "") {
        ele.value = 0;
        return;
      }
      ele.value = val;
    };
  },
});

//指定绑定 点击旋转 当前指令 rotate 依赖css .roatate 动画；
Vue.directive("rotate", {
  bind(el, binding, vnode) {
    if (binding.value) {
      el.classList.add("rotate");
    } else {
      el.classList.remove("rotate");
    }
  },
  update(el, binding) {
    if (binding.value) {
      // 'el.classList' can be use add and remove for classes
      el.classList.add("rotate");
    } else {
      el.classList.remove("rotate");
    }
  },
});
